<mat-dialog-content class="mat-typography">
    <h3>Recordá que tanto monotributistas como responsables inscriptos son considerados PyMES</h3>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center">
    <button mat-button mat-dialog-close class="boton-rojo-ftyc">Entendido</button>
</mat-dialog-actions>
